import s from './SubformMenu.module.sass'

import React, { FC, useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector, AppDispatch } from '@app/model/store'

import {
  addDishSection,
  removeDishSection,
  setFieldValid,
  setFieldValue,
} from '@pages/OwnerPersonalPage/model/OwnerPostsModel/slice'

import { OwnerCalendar } from '@pages/OwnerPersonalPage/ui/components/OwnerCalendar'
import { SubformMenuItem } from '@pages/OwnerPersonalPage/ui/components/OwnerPostForms/OwnerCreatePostForm/ui/SubformMenu/ui/SubformMenuItem'

import { Text } from '@shared/ui/Typography/Text'
import { Button } from '@shared/ui/Actions/Button'
import { InputTitle } from '@shared/ui/Form/Single/InputTitle'

import IconPlus from '@icons/icon-owner-plus.svg'
import { addDishSectionAC } from '@pages/OwnerPersonalPage/model/OwnerPostsModel/actions'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'

const SubformMenu: FC = () => {
  const dispatch = useAppDispatch() as AppDispatch
  const storeMenu = useAppSelector((store) => store?.pages?.owner_personal?.posts?.forms?.create?.categories?.menu)
  const [fieldSelectedDate, setFieldSelectedDate] = useState<Date | null>(null)

  const handleAddDish = () => {
    dispatch(addDishSectionAC() as any)
  }

  // установка данных полей из store при первом\повторных отображений компонента(value и valid)
  useEffect(() => {
    setFieldSelectedDate(storeMenu.fields.date.value ? new Date(storeMenu.fields.date.value) : null)
  }, [])

  useEffect(() => {
    const isValidDate = (d: Date | null): d is Date => d instanceof Date && !isNaN(d.getTime())

    dispatch(
      setFieldValue({
        typeField: 'date',
        value: isValidDate(fieldSelectedDate) ? fieldSelectedDate.toJSON() : new Date().toJSON(),
      }),
    )
    dispatch(setFieldValid({ typeField: 'date', valid: true }))
  }, [fieldSelectedDate])

  const handleDeleteDish = (index: number) => {
    dispatch(removeDishSection(index))
  }

  return (
    <ErrorBoundary>
      <div className={s.wrapper}>
        <Text className={s['main-description']} sizes='S'>
          Можно ввести до четырех позиций из меню. Публикуется 1 раз в сутки.
        </Text>

        {/*<div className={s['data-wrap']}>*/}
        {/*  <InputTitle nameField={'owner-date-spec'} title={'Дата публикации'} showRequired={false} />*/}
        {/*  <OwnerCalendar selectedDate={fieldSelectedDate} onChangeDate={(date) => setFieldSelectedDate(date)} />*/}
        {/*</div>*/}

        {storeMenu?.fields?.dishes?.length > 0 &&
          storeMenu.fields.dishes.map((dish, index) => (
            <SubformMenuItem
              data={dish}
              key={dish.id}
              index={index}
              handleDelete={handleDeleteDish}
              isShowButtonDelete={storeMenu?.fields?.dishes?.length > 1}
            />
          ))}

        {storeMenu?.fields?.dishes.length < 3 && (
          <Button
            sizes={'XL'}
            mode={'white-border'}
            onClick={handleAddDish}
            className={s['button-add']}
            data-testid={'add-dish'}>
            <div className={s['button-add__content']}>
              <IconPlus />
              <Text sizes={'M'}>Добавить блюдо</Text>
            </div>
          </Button>
        )}
      </div>
    </ErrorBoundary>
  )
}

export default SubformMenu
